import React, { useEffect, useState } from 'react'
import { Text } from 'components/Text'
import {
  TransactionBalanceContainer,
  TransactionBalanceTableContainer,
} from './TransactionBalance.styled'
import Table from 'components/Table'
import TransactionBalanceItem from '../TransactionBalanceItem'
import Button from 'components/Button/Button'
import { useAppDispatch, useAppState } from 'store'
import { TransactionInvoice } from 'models/transaction.model'
import { remove } from 'lodash'
import { transactionActions } from 'store/slices/transactions/transactions.slice'
import { TransactionBalanceTableProps } from './TransactionBalanceTable.props'
import Spinner from 'components/Spinner'
import { SpinnerContainer } from 'components/Spinner/Spinner.styled'
import toast from 'cogo-toast'
import { PENNIES } from 'utils/rate'
const TRANSACTION_BALANCE_HEADER: string[] = [
  '',
  'ID',
  'Transaction Type',
  'Amount',
  'Description',
]

const TransactionBalanceTable = ({
  locationId,
  clientId,
  paymentType,
  onSelectItem,
  pennies
}: TransactionBalanceTableProps) => {

  const dispatch = useAppDispatch()
  const { balance, invoices, loading } = useAppState(state => state.transaction)
  const [ selectedInvoices, setSelectedInvoices ] = useState<TransactionInvoice[]>([])
  const [ finalAmount, setFinalAmount] = useState<number>(0)

  useEffect(() => {
    if (selectedInvoices.length > 0) {
      const newAmount = calculateAmountToCharge(true)
      setFinalAmount(parseFloat(newAmount.toFixed(2)))
    } else {
      setFinalAmount(0)
    }
  }, [selectedInvoices])

  const calculateAmountToCharge = (total: boolean): number => {
    let finalAmount = 0
    selectedInvoices.forEach(invoice => {
      finalAmount = finalAmount + invoice.amount / PENNIES
    })
    return !total ? finalAmount - (balance ? balance / PENNIES : 0) : finalAmount
  }

  const handleSelected = (invoice: TransactionInvoice) => {
    const invoices = [...selectedInvoices]
    
    if (!invoice.remove) {
      invoices.push(invoice)
      setSelectedInvoices(invoices)
      return
    }

    if (invoice.remove) {
      const newInvoices = remove(invoices, element => {
        return element.id !== invoice.id
      })
      setSelectedInvoices(newInvoices)
    }
  }

  const handlePayment = async () => {
    let amount = 0
    let tax = 0
    let subtotal = 0
    const invoices: number[] = []

    selectedInvoices.forEach(invoice => {
      amount = amount + invoice.amount
      tax = tax + invoice.tax
      subtotal = subtotal + invoice.subtotal
      invoices.push(invoice.id)
    })
    await dispatch(
      transactionActions.createPaymentTransaction({
        locationId,
        clientId,
        amount,
        tax,
        subtotal,
        invoice_ids: invoices,
      })
    ).then(async () => {
      await dispatch(
        transactionActions.getTransactionUserBalance({
          locationId,
          userId: clientId,
        })
      )
      toast.success(`$${finalAmount} successfully charged to card`, {
        position: 'top-right',
      })
    })
  }

  const handlePaymentType = async () =>{
    await dispatch(
      transactionActions.getTransactionUserBalance({
        locationId,
        userId: clientId,
        paymentType
      })
    )
  }

  useEffect(()=>{
      handlePaymentType();
  }, [paymentType]);
  
  useEffect(()=>{
    onSelectItem(selectedInvoices)
  }, [selectedInvoices])

  return (
    <TransactionBalanceContainer>
      <TransactionBalanceTableContainer>
        <Table 
          header={TRANSACTION_BALANCE_HEADER} 
          styles={{ width: '100%' }}
        >
          {loading !== 'loading' &&
            invoices.map(
              invoice =>
                invoice.paid === 'unpaid' && (
                  <TransactionBalanceItem
                    onSelected={handleSelected}
                    invoice={invoice}
                    key={invoice.id}
                    pennies={pennies}
                  />
                )
            )}
        </Table>
        {loading === 'loading' && (
          <SpinnerContainer style={{ margin: '50px 0' }}>
            <Spinner loading={true} />
          </SpinnerContainer>
        )}
      </TransactionBalanceTableContainer>
    </TransactionBalanceContainer>
  )
}

export default TransactionBalanceTable
